if (!customElements.get('product-variants-data')) {

  const DEFAULT_PARTS_KEY = "default"
  class ProductVariantDataInfo extends HTMLElement {
    dataMapPartsWithVariant = {}
    partIDMapWithName = {}
    variantData = {}

    constructor() {
      super();
      // this.getInitPartValue()
      this.readData();

      // var selected = ["gid://shopify/Metaobject/31723094266", "gid://shopify/Metaobject/34125775098"]
      // this.getVariantSelected(selected)
    }

    getVariantSelected(partSelected) {

      var key = this.getPartsKey(partSelected)
      return this.dataMapPartsWithVariant[key];
    }
    getInitPartSelected() {
      var key = this.getInitKeyVariantSelected()
      return this.dataMapPartsWithVariant[key];
    }
    getInitPartValue() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantSelected = urlParams.get("variant")
      if (this.variantData[variantSelected]) {
        var partValues = this.variantData[variantSelected].parts;
        return partValues.map(el => {
          return this.partIDMapWithName[el]
        })
      }


      var partSelected = this.getElementsByTagName("part-value-selected");
      var partValues = [];
      try {
        for (let index = 0; index < partSelected.length; index++) {
          const element = partSelected[index];
          partValues.push(element.dataset.partValue)
        }
      } catch (error) {

      }
      return partValues
    }
    getInitKeyVariantSelected() {
      var partSelected = this.getElementsByTagName("part-value-selected");
      var partIds = [];
      try {
        for (let index = 0; index < partSelected.length; index++) {
          const element = partSelected[index];
          console.log("getDataVariantSelected", element.dataset);
          partIds.push(element.dataset.partValueId)
        }
      } catch (error) {

      }
      return this.getPartsKey(partIds);
    }
    readData() {
      var variants = this.getElementsByTagName("product-variant-value");
      for (let index = 0; index < variants.length; index++) {
        const element = variants[index];
        //console.log("ProductVariantDataInfo:", element.dataset);
        const variantId = element.dataset.variantId
        const parts = this.readProductPart(element, variantId);
        const data = {
          id: variantId,
          data: element.dataset,
          parts: parts
        }
        this.dataMapPartsWithVariant[this.getPartsKey(parts)] = data;
        this.variantData[data.id] = data;
      }
    }
    readProductPart(element, variantId) {
      var data = []
      var parts = element.getElementsByTagName("product-part-item");
      for (let index = 0; index < parts.length; index++) {
        const element = parts[index];
        data.push(element.dataset.shopifyId);
        this.partIDMapWithName[element.dataset.shopifyId] = element.dataset.partname
      }
      return data;
    }
    getPartsKey(parts) {
      if (parts.length == 0) {
        return DEFAULT_PARTS_KEY;
      }
      return parts.sort((el1, el2) => el1.localeCompare(el2)).join("_");
    }
  }



  customElements.define('product-variants-data', ProductVariantDataInfo)
}

